/** Copyright (c) 2020 T. Rowe Price. All rights reserved. */

import './BeaconSelectViewableAccounts.scss';
import { bool, func, object } from 'prop-types';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import {
  getGrantViewAccessAccountsForAddNew,
  isgvaEnabledAlready
} from 'state/grantViewAccess/GrantViewAccessSelectors';
import {
  getCustomer,
  getPrimaryEmailAddress
} from 'state/customer/CustomerSelectors';
import { GroupedAccountList } from 'components/shared/GroupedAccountList/GroupedAccountList';
import { GroupedAccountListHeader } from 'components/shared/GroupedAccountList/GroupedAccountListHeader';
import { AccountList } from 'components/shared/GroupedAccountList/AccountList';
import { AccountListItem } from 'components/shared/GroupedAccountList/AccountListItem';
import { getAccountHeaderClassname } from 'components/shared/GroupedAccountList/util';
import AccountDisplay from 'components/shared/AccountDisplay/AccountDisplay';
import { getView } from 'state/view/ViewSelectors';
import { AAMBeaconControl, AAMBeaconControlGroup } from 'components/shared/Beacon';

const BeaconSelectViewableAccounts = ({
  accountGroups,
  checkedItems,
  gvaEnabledAlready,
  updateCheckedItems
}) => {
  const updateCheckedItem = (name) => () => {
    updateCheckedItems({
      ...checkedItems,
      [name]: !checkedItems[name]
    });
  };

  return (
    <Fragment>
      <div className="gva-add-selectview-accounts">
        <div className="account-list-item-type-list">
          <Fragment>
            <div className="entity-disclaimer">
              {gvaEnabledAlready && (<>
                Note: Accounts currently granted to this individual are not
                displayed below. To make changes to the existing accounts they
                have view access to, close this modal and click &apos;Edit&apos;
                next to their name.
              </>)}
            </div>
          </Fragment>
          {Object.entries(accountGroups).map(
            ([accountGroupName, accounts], i) => (
              <GroupedAccountList
                key={i}
                groupClassification={getAccountHeaderClassname(accounts)}>
                <GroupedAccountListHeader accountGroupName={accountGroupName} />
                <AccountList>
                  {accounts.map((account) => (
                    <AccountListItem key={account.accountId}>
                        <AAMBeaconControlGroup>
                          <AAMBeaconControl inline>
                            <label slot="label" htmlFor={account.accountId}>
                              <AccountDisplay
                                account={account}
                                withLink={false}
                                showAccountLabel={false}
                                withOwners
                              />
                            </label>
                            <input type="checkbox"
                              onChange={updateCheckedItem(account.accountId)}
                              checked={checkedItems[account.accountId]}
                              id={account.accountId}
                              name={account.accountWChecksum} />
                          </AAMBeaconControl>
                        </AAMBeaconControlGroup>
                    </AccountListItem>
                  ))}
                </AccountList>
              </GroupedAccountList>
            )
          )}
        </div>
        <Fragment>
          <div className="entity-disclaimer">
            <>
              Note: Entities (corporations) are excluded from granting and
              receiving permission to view account(s) and use information in
              tools.
            </>

          </div>
        </Fragment>
      </div>
    </Fragment>
  );
};

BeaconSelectViewableAccounts.propTypes = {
  accountGroups: object,
  checkedItems: object,
  grantee: object,
  onBack: func,
  onSave: func,
  shouldDisableSave: bool,
  gvaEnabledAlready: bool,
  updateFormField: func
};

const mapStateToProps = (state) => ({
  accountGroups: getGrantViewAccessAccountsForAddNew(state),
  customer: getCustomer(state),
  customerEmail: getPrimaryEmailAddress(state).address || '',
  view: getView(state),
  gvaEnabledAlready: isgvaEnabledAlready(state)
});

export default connect(mapStateToProps)(BeaconSelectViewableAccounts);
